import classnames from "classnames";
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import AppLogo from "../AppLogo";
import MainNav from "../MainNav";
import UserNav from "../UserNav";
import "./styles.css";
import LocationChangeListener from "../../components/LocationChangeListener";
import { HamburgerMenu } from "../../components/VFIcon";

const mapStateToProps = (state) => {
  return {
    technikTree: state.staticPage.tree.technik,
    organisationTree: state.staticPage.menuTree.organisation,
  };
};
const mapDispatchToProps = null;

function AppHeader({ technikTree, organisationTree }) {
  const [showMenu, setShowMenu] = React.useState(false);

  const toggleMenu = React.useCallback(() => {
    setShowMenu((value) => !value);
  }, []);

  const hideMenu = React.useCallback(() => {
    setShowMenu(false);
  }, []);

  const tree = {
    technik: technikTree,
    organisation: organisationTree,
  };

  return (
    <>
      <LocationChangeListener onChange={hideMenu} />
      <header
        className={classnames("app-header", {
          "nav-display": showMenu,
        })}
      >
        <div className="menu-pane w3-border-bottom">
          <div className="container">
            <div className="w3-row">
              <div className="w3-col logo-holder">
                <Link className="app-home-link" to="/">
                  <AppLogo />
                  <span className="app-title">AN-Portal</span>
                </Link>
              </div>
              <div className="w3-col w3-right burger-holder">
                <HamburgerMenu onClick={toggleMenu} />
              </div>
              <div className="w3-col w3-right user-nav-holder">
                <UserNav />
              </div>
              <div className="w3-rest">
                <MainNav tree={tree} />
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}

AppHeader.propTypes = {
  technikTree: PropTypes.shape({}),
  salesTree: PropTypes.shape({}),
  organisationTree: PropTypes.shape({}),
};

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
